import { defineComponent as _defineComponent } from 'vue'
import Label from '@/components/form/LabelComponent.vue'
import Modal from '@/components/ModalComponent.vue'
import { store } from '@/store/store';
import { computed,onMounted, ref } from "vue";
import { useTranslator } from "@/composables/useTranslator";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyCodeComponent',
  emits: ['hideModal'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { t } = useTranslator();
const emits = __emit

const id = ref<number>(Math.ceil(Math.random()*1000000))
const companyCode = ref<string>('');
const companyFound = computed<boolean>(() => store.state.employer.company !== '' && store.state.employer.company !== '---');

const handleCompanyCodeInput = async () => {
  if (companyCode.value.length > 3 && companyCode.value.length <= 6) {

    const attemptSetEmployer = await store.dispatch('setEmployerByCompanyCode', companyCode.value.toUpperCase())
    if (attemptSetEmployer) {
      emits('hideModal')
    }
  }
}

const handleContinueWithoutCode = () => {
  emits('hideModal')
}


onMounted(async () => {
  await store.dispatch('resetEmployer');
})


const __returned__ = { t, emits, id, companyCode, companyFound, handleCompanyCodeInput, handleContinueWithoutCode, Label, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})